<template>
  <div class="feed-block-item" :class="{ read: feed.read }">
    <header>
      <h4 v-cleaned="feed.title" class="title" />
      <div class="icon-not-read" />
    </header>

    <div class="content">
      <img :src="feed.iconMedia.urlCompressed" :alt="feed.title" />
      <div class="details">
        <p v-cleaned="feed.message" class="details" />
        <span class="time">{{ feed.delayStr }}</span>
      </div>
    </div>

    <footer v-if="feed.actions && feed.actions.length">
      <ul>
        <li v-for="action in feed.actions" :key="action.label">
          <FeedButtonAction :feed="feed" :action="action" />
        </li>
      </ul>
    </footer>
  </div>
</template>

<script setup lang="ts">
interface Props {
  feed: FeedSchema;
}
defineProps({
  feed: null
});
</script>
<style lang="scss" scoped>
header {
  display: flex;
  justify-content: space-between;
  .icon-not-read {
    flex-shrink: 0;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background-color: #d02d2d;
  }
}
.feed-block-item {
  display: flex;
  flex-direction: column;
  max-width: 40rem;
  padding: var(--gap_m);
  transition: background-color 500ms $ease-out-quad;
  border-color: var(--color_secondary_lighter);
  background-color: var(--color_secondary_lighter);
  gap: var(--gap_m);
  @include stroke('m', 'm');
  &.read {
    border-color: var(--color_secondary_lighter);
    background-color: var(--color_neutral_25);
    .icon-not-read {
      transform: scale(0);
      transition: transform 500ms $ease-in-back;
    }
  }
}
.title {
  @include font('n', 600, 'secondary');

  color: var(--color_neutral_800);
}
.details {
  @include font('n', 400, 'secondary');

  color: var(--color_neutral_800);
  strong {
    @include font('n', 600, 'secondary');

    color: var(--color_neutral_900);
  }
}
.time {
  @include font('n', 400);

  color: var(--color_secondary);
}

.content {
  display: grid;
  grid-template-columns: 4.6rem 1fr;
  gap: var(--gap_m);
}

footer {
  ul {
    display: flex;
    flex-wrap: wrap;
    gap: var(--gap_xs);
  }
}
</style>
